import { render } from "./bigStory.vue?vue&type=template&id=1ae3728a&scoped=true"
import script from "./bigStory.vue?vue&type=script&lang=js"
export * from "./bigStory.vue?vue&type=script&lang=js"

import "./bigStory.vue?vue&type=style&index=0&id=1ae3728a&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae3728a"]])

export default __exports__